export type AutoDispatchSelectionParams = {
  /** 車両行を 1 つ以上選んでいるか */
  hasSelectedVehicle: boolean;
  /** 選んだ車両がすべて「計画無」か（1 台でも配車済みがあれば false） */
  allSelectedVehiclesHaveNoPlan: boolean;
  /** 未割当案件を 1 件以上選んでいるか */
  hasSelectedUnassigned: boolean;
};

/**
 * 選択の状態から見た「自動配車を押せない理由」。押せるなら null。
 *
 * - 配車済みの車両を選んでいれば、その車両の割当を組み直せるので案件の選択は要らない
 * - 計画無の車両だけを選んでいるときは、割り当てるものが無いので案件の選択が要る
 *
 * ライセンス・実行中などの理由は resolveAutoDispatchAvailability が持つ。
 * ここは選択だけを見る（層を混ぜると、どちらを直せば押せるのか利用者に伝わらない）。
 */
export function resolveAutoDispatchSelectionReason({
  hasSelectedVehicle,
  allSelectedVehiclesHaveNoPlan,
  hasSelectedUnassigned,
}: AutoDispatchSelectionParams): string | null {
  if (!hasSelectedVehicle) return '車両を選択してください';
  if (allSelectedVehiclesHaveNoPlan && !hasSelectedUnassigned) return '未割当案件を選択してください';
  return null;
}
